const initNightSecrets = (root = document) => {
  const triggers = [];
  if (root instanceof Element && root.matches('[data-night-secret-trigger]')) triggers.push(root);
  triggers.push(...root.querySelectorAll('[data-night-secret-trigger]'));
  triggers.forEach((trigger) => {
    if (trigger.dataset.nightSecretBound === 'true') return;
    trigger.dataset.nightSecretBound = 'true';
    trigger.addEventListener('click', () => {
      const wrapper = trigger.closest('[data-night-secret]');
      const hero = trigger.closest('.editorial-hero');
      const message = wrapper?.querySelector('[data-night-secret-message]');
      if (!message) return;
      const open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!open));
      message.hidden = open;
      hero?.classList.toggle('secret-awake', !open);
    });
  });
};
document.addEventListener('DOMContentLoaded', () => initNightSecrets());
document.addEventListener('shopify:section:load', (event) => initNightSecrets(event.target));
